import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria, Importer } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useImporters = (criteria: CompanyCriteria) =>
  useQuery({
    queryKey: ['importers', hashKey([criteria])],
    queryFn: async () => {
      try {
        const result = await apiClient.importer.retrieveImporters.mutation({ body: { criteria } });
        if (result.status !== 200) throw result.body;

        return result.body.importers as Importer[];
      } catch (error) {
        showErrorToast(error, 'Failed to fetch importers');
      }
    },
  });
